import "../Styles/Contact.css";
import MailIcon from "@mui/icons-material/Mail";
import CallIcon from "@mui/icons-material/Call";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import HomeIcon from "@mui/icons-material/Home";

export const Contact = () => {
  return (
    <div id="contact" className="contact">
      <p className="contact-header">Contact</p>
      <div className="contact-content">
        <div className="contact-content-component">
          <MailIcon fontSize="large" />
          <div>onlyaditya001@gmail.com</div>
        </div>
        <div className="contact-content-component">
          <CallIcon fontSize="large" />
          <div>+91 7012423588</div>
        </div>
        <div className="contact-content-component">
          <GitHubIcon fontSize="large" />
          <div>github.com/onlyaditya</div>
        </div>
        <div className="contact-content-component">
          <LinkedInIcon fontSize="large" />
          <div>linkedin.com/aditya-nj2</div>
        </div>
        <div className="contact-content-component">
          <HomeIcon fontSize="large" />
          <div>Dehri-On-sone, Bihar</div>
        </div>
      </div>
    </div>
  );
};
